import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ModalController } from '@ionic/angular';
import { ApiService } from 'src/app/services/api/api.service';
import { LoadingService } from 'src/app/services/loading.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-edit-rhythm',
  templateUrl: './edit-rhythm.component.html',
  styleUrls: ['./edit-rhythm.component.scss'],
  standalone: false
})
export class EditRhythmComponent implements OnInit {
  @Input() data: any;
  @Input() info: any;
  editDayForm: FormGroup;
  dcReasons: any;
  today: string = new Date().toISOString().split('T')[0];
  constructor(
    private apiService: ApiService,
    private modal: ModalController,
    private toastService: ToastService,
    private loadingService: LoadingService
  ) {}
  ngOnInit() {
    console.log(this.data);
    console.log(this.info);
    this.editDayForm = new FormGroup<any>({
      //dwell_date: new FormControl(null),
      id: new FormControl(null, Validators.required),
      monitoring_date: new FormControl(null, Validators.required),
      dressing_intact: new FormControl(false),
      securement: new FormControl(null),
      completed_therapy: new FormControl(false),
      dc_reason: new FormControl(null),
      notes: new FormControl(null),
      flushes: new FormControl(null),
      blood_return: new FormControl(false),
      clamped: new FormControl(null),
      device_related_adverse_events: new FormControl(null),
    });
    this.getReasons();

    // Strip ISO time/zone so the native <input type="date"> renders the stored
    // calendar day, not the local-TZ conversion of UTC midnight.
    if (this.data?.monitoring_date) {
      this.data.monitoring_date = String(this.data.monitoring_date).split('T')[0];
    }
    this.editDayForm.patchValue(this.data);

  }
  closeModal(){
    this.editDayForm.reset()
    this.modal.dismiss('cancelled');
  }
  async submit(){
    await this.loadingService.presentLoading('');
    this.editDayForm.value.insertion_id = this.info.id;
    this.editDayForm.value.product_id = this.info.product_id;
    this.editDayForm.value.hospital_id = this.info.hospital_id;
    this.editDayForm.value.product_type = this.info.product_type;
    console.log(this.editDayForm)
    this.apiService.post('insertion_lifecycle/update',this.editDayForm.value).subscribe(async res=>{
      await this.loadingService.dismissLoader();
      this.toastService.presentSuccessToast(res.message);
      this.editDayForm.reset();
      await this.loadingService.dismissLoader();
      this.modal.dismiss('submitted');
    },
    async (error) => {
      await this.loadingService.dismissLoader();
      this.toastService.presentErrorToast(error.message);
    })

}
getReasons() {
  this.apiService.get(`products_insertion/getDCList/5`).subscribe((res) => {
    this.dcReasons = res.data;

    this.editDayForm.patchValue({dc_reason:this.data?.dc_lifecycle?.id})
  });
}


}
